{
  "locale": "Español",
  "sidebar": {
    "title": "Solicitud de intercambio de datos",
    "issuanceTitle": "Solicitud para añadir datos",
    "authenticationTitle": "Solicitud de autenticación",
    "description": "{clientName} solicita datos personales verificados de su aplicación de identidad. Revise los detalles a continuación y apruebe o rechace esta solicitud en su aplicación de identidad.",
    "issuanceDescription": "{clientName} está añadiendo datos verificados a su aplicación de identidad. Revise los detalles a continuación y confirme en su aplicación de identidad si desea aceptarlos.",
    "authenticationDescription": "{clientName} quiere autenticarse con su aplicación de identidad.",
    "descriptionFallback": "Un servicio solicita datos personales verificados de su aplicación de identidad. Revise los detalles a continuación y apruebe o rechace esta solicitud en su aplicación de identidad.",
    "issuanceDescriptionFallback": "Un servicio está añadiendo datos verificados a su aplicación de identidad. Revise los detalles a continuación y confirme en su aplicación de identidad si desea aceptarlos.",
    "authenticationDescriptionFallback": "Un servicio quiere autenticarse con su aplicación de identidad.",
    "stepsTitle": "Pasos a completar",
    "stepShareData": "Compartir datos con {clientName}",
    "stepAuthenticate": "Autenticarse para {clientName}",
    "stepReceiveData": "Recibir datos de {clientName}",
    "stepGeneric": "Completar los pasos requeridos",
    "defaultClientName": "el servicio",
    "requestedDataTitle": "Se solicitan los siguientes datos",
    "issuedDataTitle": "Se emitirán los siguientes datos",
    "reviewNotice": "Revisará y aprobará los datos exactos en su aplicación de identidad antes de que se comparta nada.",
    "issuanceReviewNotice": "Revisará y aprobará los datos exactos en su aplicación de identidad antes de que se añada nada.",
    "indeterminateHint": "Los datos solicitados serán visibles después de seleccionar una aplicación de identidad",
    "terms": "Términos",
    "termsLink": "Términos",
    "privacyLink": "Política de privacidad",
    "showAll": "Mostrar todo",
    "purposeStatementTitle": "Por qué se necesitan sus datos",
    "retentionPolicyTitle": "Cómo se manejan sus datos"
  },
  "footer": {
    "powered": "Desarrollado por",
    "terms": "Términos"
  },
  "topBar": {
    "openMenu": "Abrir menú",
    "closeMenu": "Cerrar menú",
    "help": "Ayuda",
    "language": "Idioma"
  },
  "app": {
    "error": "Error",
    "loadingTitle": "Cargando",
    "loadingHint": "Un momento por favor"
  },
  "language": {
    "en": "English",
    "nl": "Nederlands",
    "de": "Deutsch",
    "fr": "Français",
    "sv": "Svenska",
    "es": "Español",
    "search": "Buscar",
    "noResults": "Sin resultados"
  },
  "init": {
    "title": "Procesando solicitud",
    "hint": "Preparando tu sesión"
  },
  "pairing": {
    "title": "Preparando el siguiente paso",
    "hint": "Preparando tu sesión",
    "codeLabel": "Verifique el siguiente código en su aplicación de identidad",
    "confirm": "Confirmar emparejamiento"
  },
  "waitingForPresentation": {
    "title": "Continúe en su aplicación de identidad",
    "hint": "Revise su aplicación de identidad para examinar y aprobar la solicitud"
  },
  "agentStart": {
    "title": "Continuar en {appName}",
    "subtitle": "Para compartir sus datos de forma segura, escanee este código QR con {appName} para revisar y aprobar la solicitud.",
    "issuanceSubtitle": "Para recibir los datos de forma segura, escanee este código QR con {appName} para revisar y aprobar la solicitud.",
    "step1": "Abrir {appName}",
    "step2": "Hacer clic en el icono del escáner",
    "step3": "Escanear este código QR",
    "changeApp": "Cambiar aplicación de identidad",
    "installInstructions": "Instrucciones de instalación",
    "cancel": "Cancelar",
    "needHelp": "¿Necesita ayuda?",
    "redirectSubtitle": "Haga clic en el botón de abajo para abrir {appName} y aprobar la solicitud.",
    "issuanceRedirectSubtitle": "Haga clic en el botón de abajo para abrir {appName} y aprobar la solicitud.",
    "redirectButton": "Continuar",
    "mobileSubtitle": "Para compartir sus datos de forma segura, continúe en {appName} para revisar y aprobar la solicitud.",
    "issuanceMobileSubtitle": "Para recibir los datos de forma segura, continúe en {appName} para revisar y aprobar la solicitud.",
    "openApp": "Abrir {appName}",
    "showQr": "Mostrar código QR"
  },
  "done": {
    "disclosure": {
      "title": "Los datos se han compartido con éxito",
      "subtitle": "La página se cerrará automáticamente en unos segundos.",
      "subtitleCloseTab": "Datos compartidos con éxito. Puede cerrar esta página."
    },
    "issuance": {
      "title": "Datos recibidos con éxito",
      "subtitle": "La página se cerrará automáticamente en unos segundos.",
      "subtitleCloseTab": "Datos recibidos con éxito. Puede cerrar esta página."
    },
    "redirecting": "Redirigiendo...",
    "completeRedirect": "Completar y redirigir",
    "redirectFailed": "La redirección automática no funcionó. Toca abajo para continuar."
  },
  "abort": {
    "cancel": {
      "title": "Proceso detenido",
      "subtitle": "Ha elegido detener el proceso. Puede reiniciar en cualquier momento."
    },
    "techFail": {
      "title": "Algo salió mal",
      "subtitle": "No pudimos completar el proceso debido a un problema técnico."
    },
    "timeout": {
      "title": "Sesión expirada",
      "subtitle": "Esta sesión finalizó después de un período de inactividad. Para continuar, cierre esta página y reinicie el proceso."
    },
    "networkLoss": {
      "title": "Conexión perdida",
      "subtitle": "Su conexión a Internet se interrumpió. Verifique su conexión e intente de nuevo."
    },
    "backendDowntime": {
      "title": "Servicio temporalmente no disponible",
      "subtitle": "El servicio está en mantenimiento actualmente. Intente de nuevo más tarde."
    },
    "appUnavailable": {
      "title": "Aplicación de identidad no disponible",
      "subtitle": "No pudimos conectar con la aplicación de identidad seleccionada. La aplicación puede estar temporalmente no disponible. Puede probar con otra aplicación de identidad o intentar de nuevo más tarde."
    },
    "selectDifferentApp": "Seleccionar otra aplicación de identidad",
    "confirmTitle": "¿Detener el proceso?",
    "confirmMessage": "¿Está seguro de que desea detenerse? Puede reiniciar en cualquier momento si desea continuar más tarde.",
    "confirmCancel": "Cancelar",
    "confirmStop": "Detener proceso",
    "goBack": "Volver",
    "leave": "Salir",
    "closePage": "Cerrar página",
    "restart": "Reiniciar",
    "retry": "Reintentar"
  },
  "appPicker": {
    "title": "Aplicaciones de identidad compatibles",
    "subtitle": "Las siguientes aplicaciones de identidad se pueden usar para revisar y aprobar la solicitud",
    "searchPlaceholder": "Buscar...",
    "sectionLastUsed": "Último usado",
    "sectionRecommended": "Recomendado",
    "sectionAZ": "A-Z",
    "noResults": "Ninguna aplicación coincide con su búsqueda",
    "filterTitle": "Filtrar por país",
    "filterClear": "Borrar todo",
    "filterDone": "Hecho"
  },
  "faq": {
    "helpQuestion": "Pregunta",
    "moreHelp": "Más ayuda",
    "close": "Cerrar",
    "whatAreWallets": {
      "title": "¿Qué son las aplicaciones de identidad?",
      "body": "Con una aplicación de identidad, usted controla sus propios datos — usted solo decide qué datos comparte, con quién y cuándo. Sus datos se recuperan de un emisor confiable y verificado y se almacenan en la aplicación junto con una firma digital que garantiza su precisión.\n\nCuando comparte datos con un tercero, la firma digital se incluye para que la parte receptora pueda verificar su autenticidad. Sus datos generalmente se almacenan solo en su propio teléfono y pueden recuperarse fácilmente si es necesario.\n\nTenga en cuenta que es su responsabilidad elegir cuidadosamente con quién comparte sus datos."
    },
    "whyNotSupported": {
      "title": "¿Por qué no se admite mi aplicación de identidad?",
      "body": "Puede suceder que su aplicación de identidad no esté disponible porque la parte receptora o nuestra plataforma no la admite actualmente. Estamos trabajando constantemente para ampliar nuestra gama de aplicaciones compatibles.\n\nSi su aplicación no está en la lista, siempre puede instalar y usar una de las otras aplicaciones de identidad compatibles."
    },
    "howDataProtected": {
      "title": "¿Cómo se protegen mis datos?",
      "body": "Las aplicaciones de identidad garantizan que siempre tenga control sobre con quién comparte sus datos y cuándo. Generalmente le brindan una descripción general de los datos que ha compartido, con quién y cuándo.\n\nVer.iD envía sus datos directamente a la parte receptora y solo verifica que se hayan entregado correctamente. Todos los datos se procesan de acuerdo con el Reglamento General de Protección de Datos (GDPR). La parte receptora aplica sus propias reglas de protección y se lo comunicará.\n\nTenga en cuenta que es su responsabilidad elegir cuidadosamente con quién comparte sus datos."
    },
    "howObtainData": {
      "title": "¿Cómo puedo poner datos en mi aplicación?",
      "body": "Cada aplicación de identidad tiene su propia forma de recopilar datos. La mayoría de las aplicaciones tienen un botón para agregar datos. En algunos casos, puede haber costos asociados.\n\nSiga las instrucciones de la aplicación para recopilar sus datos de manera segura. Es posible que se le redirija a sitios web gubernamentales o que deba escanear documentos como pasaportes o licencias de conducir.\n\nSi no ve una forma directa de agregar los datos correctos, consulte la documentación de la aplicación o comuníquese con el proveedor. También puede intentar con otra aplicación de identidad."
    },
    "whyRedirection": {
      "title": "¿Por qué me están redirigiendo?",
      "body": "Algunas aplicaciones de identidad requieren una redirección a su propio sitio web para que sus datos se compartan de acuerdo con sus estándares, en un entorno que usted conoce.\n\nDespués de compartir exitosamente, será redirigido automáticamente a Ver.iD, donde sus datos esperarán su confirmación antes de ser enviados a la parte receptora. Un recibo digital generalmente se encuentra en su aplicación de identidad.\n\nSi el proceso falla o se cancela, también será redirigido y podrá intentarlo de nuevo."
    }
  },
  "dataReview": {
    "title": "Revise los datos",
    "subtitleDisclosure": "Antes de compartir, tómese un momento para revisar los datos que se compartirán con {clientName}.",
    "subtitleIssuance": "Antes de aceptar, tómese un momento para revisar los datos que recibirá de {clientName}.",
    "issuedBy": "Datos emitidos por",
    "attribute": "Atributo",
    "value": "Valor",
    "cancel": "Cancelar",
    "acceptShare": "Aceptar",
    "acceptReceive": "Aceptar",
    "unknownClient": "el servicio",
    "loadingNames": "Cargando nombres de datos...",
    "errorLoadingNames": "No se pudieron cargar los nombres de datos. Intente de nuevo."
  },
  "mobileFlowStart": {
    "startVerification": "Continuar",
    "selectApp": "Seleccionar aplicación de identidad"
  },
  "requestedDataModal": {
    "title": "Datos solicitados",
    "subtitle": "Revisará y aprobará esta solicitud en su aplicación de identidad.",
    "attribute": "Atributo",
    "description": "Descripción",
    "issuedBy": "Datos emitidos por",
    "close": "Cerrar"
  },
  "demo": {
    "title": "Entorno de demostración",
    "description": "Está usando una demostración interactiva de Ver.iD. Este entorno está destinado únicamente a fines de demostración."
  },
  "installInstructions": {
    "title": "Instalar {appName}",
    "subtitle": "Visite la App Store o Play Store en su teléfono para instalar la aplicación de identidad {appName}. Escanee el código para abrir directamente la página de la tienda e instalar la aplicación.",
    "close": "Cerrar",
    "unavailableTitle": "Instrucciones no disponibles",
    "unavailableBody": "Lo sentimos, no tenemos instrucciones de instalación disponibles para esta aplicación en este momento. Intente buscar manualmente la aplicación en la tienda de aplicaciones para continuar."
  }
}
